export default new (class TabForm {
    constructor() {
        this.tab = 'tab';
        this.tabItem = 'tabs-form-item';
        this.tabItemInited = 'tab-menu-item-inited';
        this.tabContents = 'tabs-form-contents';
        this.tabContent = 'tabs-form-content';

        document.addEventListener("DOMContentLoaded", () => {
            this.initHandler();
        });
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.querySelectorAll(`.${this.tabItem}`).forEach((item) => {
            if (item.classList.contains(this.tabItemInited)) return;
            item.classList.add((this.tabItemInited));
            item.addEventListener('click', (e) => {
                e.preventDefault();
                let tabId = item.getAttribute('data-tab');
                let tab = item.closest(`.${this.tab}`);

                tab.querySelectorAll(`.${this.tabItem}`).forEach((item) => {
                    item.classList.remove('active')
                });
                tab.querySelectorAll(`.${this.tabContent}`).forEach((item) => {
                    item.classList.remove('active')
                });

                item.classList.add('active')
                tab.querySelector(`.${this.tabContent}[data-tab="${tabId}"]`).classList.add('active')
            });
        });
    }
})()
